import { AdminApiError, request } from '../api/client.js'
import type {
  ListSuppressionsParams,
  ReleaseResult,
  SuppressionDetailResponse,
  SuppressionListResponse,
} from './types.js'

const BASE = '/coach/admin/email-suppressions'

export const adminEmailSuppressionsApi = {
  list(params: ListSuppressionsParams = {}): Promise<SuppressionListResponse> {
    const qs = new URLSearchParams()
    if (params.status) qs.set('status', params.status)
    if (params.email) qs.set('email', params.email)
    if (params.limit !== undefined) qs.set('limit', String(params.limit))
    if (params.offset !== undefined) qs.set('offset', String(params.offset))
    const suffix = qs.size > 0 ? `?${qs.toString()}` : ''
    return request<SuppressionListResponse>(`${BASE}${suffix}`, {
      method: 'GET',
    })
  },
  get(emailHash: string): Promise<SuppressionDetailResponse> {
    return request<SuppressionDetailResponse>(`${BASE}/${emailHash}`, {
      method: 'GET',
    })
  },
  release(emailHash: string): Promise<ReleaseResult> {
    return request<ReleaseResult>(`${BASE}/${emailHash}/release`, {
      method: 'POST',
    })
  },
}

export function messageForSuppressionError(error: unknown): string {
  if (error instanceof AdminApiError) {
    switch (error.detail) {
      case 'suppression_not_found':
        return 'That address is no longer on the undeliverable list.'
      case 'invalid_email_hash':
        return 'That link is malformed — open the address from the list instead.'
      case 'admin_required':
        return 'You do not have permission to manage the undeliverable list.'
      default:
        return error.message
    }
  }
  return error instanceof Error ? error.message : 'Request failed'
}
